<h2 mat-dialog-title>
  <mat-icon>image_search</mat-icon>
  Conversations with image upload
</h2>

<mat-dialog-content>
  <div [hidden]="!isLoading" class="loading-state">
    <mat-progress-spinner
      diameter="40"
      mode="indeterminate"
    ></mat-progress-spinner>
    <span>Loading image convos...</span>
  </div>

  <div [hidden]="resultsLength !== 0 && !isLoading" class="no-convos-state">
    <span>No image uploads for that date range.</span>
  </div>

  <div [hidden]="isLoading || resultsLength === 0">
    <table mat-table [dataSource]="conversations" class="mat-elevation-z2">
      <ng-container matColumnDef="planNumber">
        <th mat-header-cell *matHeaderCellDef>Plan Number</th>
        <td mat-cell *matCellDef="let element">
          <span
            [ngClass]="
              this.showPlanNumber
                ? 'plan-number-revealed'
                : 'plan-number-blurred'
            "
          >
            {{ element.planNumber }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="productType">
        <th mat-header-cell *matHeaderCellDef>Product Type</th>
        <td mat-cell *matCellDef="let element">{{ element.productType }}</td>
      </ng-container>

      <ng-container matColumnDef="sessionId">
        <th mat-header-cell *matHeaderCellDef>Session ID</th>
        <td mat-cell *matCellDef="let element">{{ element.sessionId }}</td>
      </ng-container>

      <ng-container matColumnDef="messageHistory">
        <th mat-header-cell *matHeaderCellDef>Message History</th>
        <td mat-cell *matCellDef="let element">
          <button mat-button color="accent" (click)="viewConversation(element)">
            View
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      (page)="fetchImageConversations($event)"
      [length]="resultsLength"
      [pageSize]="5"
      [pageSizeOptions]="[10, 25, 60, 100]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
